import React, { useState } from 'react';

const AerospaceIntroductioncards = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div style={{ textAlign: 'center', marginTop: '80px' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '20px', color: 'rgb(254 153 0)' }}>
                Crigot framework <span style={{ color: '#000' }}>Offering</span>
            </h1>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center', // Center cards horizontally
                    alignItems: 'center', // Center cards vertically (if needed)
                    gap: '30px', // Decreased gap between cards
                    padding: '20px',
                    backgroundColor: '#fff',
                    overflow: 'hidden', // Prevent horizontal scroll
                }}
            >
                {/* Card 1 */}
                <div
                    style={{
                        width: '300px', // Decreased width
                        height: '330px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', // Center content vertically
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 0 ? 'rgb(254, 153, 0)' : '',
                        transform: hoveredIndex === 0 ? 'scale(1.05)' : 'scale(1)', // Zoom effect
                    }}
                    onMouseEnter={() => setHoveredIndex(0)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <h1
                        style={{
                            fontSize: '18px',
                            padding: '0 10px',
                            marginBottom: "54px",
                            color: hoveredIndex === 0 ? '#fff' : '#000', // Change text color on hover
                        }}
                    >
                        "Create a unified compliance framework tailored for healthcare regulations."
                    </h1>
                    <p
                        style={{
                            color: hoveredIndex === 0 ? '#fff' : '#000', // Change text color on hover
                            textAlign: 'justify',
                            padding: '0 10px',
                        }}
                    >
                        We design an integrated control framework that ensures seamless compliance with above regulations, guidelines, minimizing regulatory risks and enabling.
                    </p>
                </div>

                {/* Card 2 */}
                <div
                    style={{
                        width: '300px', // Decreased width
                        height: '330px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', // Center content vertically
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 1 ? 'rgb(254, 153, 0)' : '',
                        transform: hoveredIndex === 1 ? 'scale(1.05)' : 'scale(1)', // Zoom effect
                    }}
                    onMouseEnter={() => setHoveredIndex(1)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <h1
                        style={{
                            fontSize: '18px',
                            padding: '0 10px',
                            marginBottom: "54px",
                            color: hoveredIndex === 1 ? '#fff' : '#000', // Change text color on hover
                        }}
                    >
                        "Identify vulnerabilities, assess regulatory gaps, and prioritize actions with precision."
                    </h1>
                    <p
                        style={{
                            color: hoveredIndex === 1 ? '#fff' : '#000', // Change text color on hover
                            textAlign: 'justify',
                            padding: '0 10px',
                        }}
                    >
                        Through advanced risk and impact assessments, we uncover gaps in your healthcare operations, from clinical trial compliance to data privacy, enabling targeted interventions.
                    </p>
                </div>

                {/* Card 3 */}
                <div
                    style={{
                        width: '300px', // Decreased width
                        height: '330px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', // Center content vertically
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 2 ? 'rgb(254, 153, 0)' : '',
                        transform: hoveredIndex === 2 ? 'scale(1.05)' : 'scale(1)', // Zoom effect
                    }}
                    onMouseEnter={() => setHoveredIndex(2)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <h1
                        style={{
                            fontSize: '18px',
                            padding: '0 10px',
                            marginBottom: "54px",
                            color: hoveredIndex === 2 ? '#fff' : '#000', // Change text color on hover
                        }}
                    >
                        "Redefine governance with intelligent remediation and dynamic controls."
                    </h1>
                    <p
                        style={{
                            color: hoveredIndex === 2 ? '#fff' : '#000', // Change text color on hover
                            textAlign: 'justify',
                            padding: '0 10px',
                        }}
                    >
                        We strengthen your governance landscape by addressing deficient controls, implementing robust policies, and creating an integrated risk and controls matrix to future-proof compliance.
                    </p>
                </div>

                {/* Card 4 */}
                <div
                    style={{
                        width: '300px',
                        height: '330px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 3 ? 'rgb(254, 153, 0)' : '',
                        transform: hoveredIndex === 3 ? 'scale(1.05)' : 'scale(1)',
                    }}
                    onMouseEnter={() => setHoveredIndex(3)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <h1
                        style={{
                            fontSize: '18px',
                            padding: '0 10px',
                            marginBottom: '54px',
                            color: hoveredIndex === 3 ? '#fff' : '#000', // Change text color on hover
                        }}
                    >
                        "Redefine governance with intelligent remediation and dynamic controls."
                    </h1>
                    <p
                        style={{
                            color: hoveredIndex === 3 ? '#fff' : '#000', // Change text color on hover
                            textAlign: 'justify',
                            padding: '0 10px',
                        }}
                    >
                        We strengthen your governance landscape by addressing deficient controls, implementing robust policies, and creating an integrated risk and controls matrix to future-proof compliance.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default AerospaceIntroductioncards;
